module.exports = __webpack_public_path__ + "static/media/cal.da981797.svg";